module.exports = __webpack_public_path__ + "img/beer_id-120.70c85359.png";